import { getGas } from './gasDatabase';

export type CollectionMethod = 'water-displacement' | 'upward-delivery' | 'downward-delivery';

export interface CollectionDecision {
  method: CollectionMethod;
  reason: string;
}

export function determineCollectionMethod(gasId: string): CollectionDecision {
  const gas = getGas(gasId);

  if (gas.solubility === 'insoluble' || gas.solubility === 'slightly-soluble') {
    return {
      method: 'water-displacement',
      reason: `${gas.name} is only slightly or not soluble in water, so it can be collected over water.`,
    };
  }

  if (gas.densityRelativeToAir > 1) {
    return {
      method: 'downward-delivery',
      reason: `${gas.name} is denser than air and is best collected by downward delivery.`,
    };
  }

  return {
    method: 'upward-delivery',
    reason: `${gas.name} is less dense than air and is best collected by upward delivery.`,
  };
}
